export default __webpack_public_path__ + "static/media/success-btn.75a20cb4.svg";